import React, { Fragment, useState } from "react";
import { Box, Modal, Typography, Grid, Button } from "@material-ui/core";
import { httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import ButtonLoader from "./ButtonLoader";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import ToastModal from "./ToastModal";
import { Environment } from "../utils/environments";

const ConfirmationModal = ({
  open,
  heading,
  body,
  confirmButton,
  confirmButtonText,
  closeButton,
  closeButtonText,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [checkedOne, setCheckedOne] = useState<boolean>(false);
  const [checkedTwo, setCheckedTwo] = useState<boolean>(false);
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "white",
    boxShadow: 24,
    p: 6,
  };
  return (
    <Fragment>
      <Modal open={open} onClose={() => closeButton(false)}>
        <Box className="modal-wrapper">
          <Box className="modal">
            <Box className="modal-body">
              <div>
                <Grid
                  container
                  justifyContent="center"
                  style={{ marginTop: "1.5rem" }}
                >
                  <Grid item md={10}>
                    <Typography
                      variant="h5"
                      color="primary"
                      style={{
                        fontWeight: "800",
                        marginBottom: "1.5rem",
                        fontFamily: "Noto Serif JP",
                      }}
                    >
                      {heading}
                    </Typography>
                    <Typography
                      style={{
                        marginBottom: "2rem",
                        color: "var(--text-color-2)",
                        fontWeight: "800",
                      }}
                    >
                      {body}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  style={{ marginTop: "1.5rem" }}
                >
                  <Grid item md className="modal-button-wrapper">
                    <button className="main-btn" onClick={confirmButton}>
                      {loading ? (
                        <ButtonLoader btnColor="light" />
                      ) : (
                        confirmButtonText
                      )}
                    </button>
                    <button
                      className="secondary-btn"
                      onClick={() => closeButton(false)}
                    >
                      {closeButtonText}
                    </button>
                  </Grid>
                </Grid>
              </div>
            </Box>
          </Box>
        </Box>
      </Modal>
      {showToast && (
        <ToastModal
          errorModal={showToast}
          setErrorModal={setShowToast}
          message={"未使用のサポートチケットがあるため、退会できません"}
        />
      )}
    </Fragment>
  );
};

export default ConfirmationModal;
